module.exports = __webpack_public_path__ + "img/cooperate_qy_04@2x.e23ccb38.png";